<template>
  <section id="Sponsorer" class="section">
    <div class="section-header js-section-header">
      <h2>Sponsorer</h2>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="row sponsor-container">
            <div
              class="col-12 col-sm-3 col-md-4 col-lg-3 py-2 text-center"
              v-for="sponsor of getSponsors"
              :key="sponsor.name"
            >
              <a
                :href="sponsor.url"
                target="_blank"
                :title="sponsor.name"
                v-if="sponsor.show"
                rel="noopener"
              >
                <img
                  class="img-fluid"
                  :alt="sponsor.name"
                  :src="sponsor.image"
                  style="max-height: 100px"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SPONSORS",
  computed: {
    getSponsors: function(){
      return this.$root.eventData.sponsors.filter(s => s.show === true);
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  background-image: none;
  box-shadow: inset 0 2px 20px 0px rgba(0, 0, 0, 0.3);
}
</style>
